import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

const LoginPage = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    const ok = await login(email, password);
    setLoading(false);
    if (!ok) {
      setErr("Invalid email or password");
      toast.error("Login failed");
    } else {
      toast.success("Welcome back!");
    }
  };

  return (
    <div className="grid min-h-screen grid-cols-1 md:grid-cols-2">
      <div className="flex flex-col justify-center px-8 py-12 md:px-20">
        <div className="mb-12 flex items-center gap-3">
          <img src="/logo.png" alt="Excellent Plastic" className="h-14 w-14 object-contain" />
          <div>
            <h1 className="font-heading text-xl font-extrabold uppercase leading-tight tracking-tight text-[#1E40AF]" data-testid="brand-heading">
              Excellent Plastic Materials Trading LLC
            </h1>
            <p className="mt-1 text-xs uppercase tracking-widest text-slate-500">Quote Management System</p>
          </div>
        </div>
        <Card className="rounded-sm border-[#E5E7EB] p-8 shadow-none">
          <h2 className="font-heading text-3xl font-bold ep-text-primary">Sign in</h2>
          <p className="mt-2 text-sm text-slate-500">
            Authorised personnel only. Use your company credentials.
          </p>
          <form onSubmit={handleSubmit} className="mt-8 space-y-5">
            <div>
              <Label htmlFor="email" className="text-xs font-semibold uppercase tracking-wider text-slate-600">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@excellentplastic.com"
                className="mt-1 rounded-sm"
                required
                data-testid="login-email-input"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs font-semibold uppercase tracking-wider text-slate-600">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 rounded-sm"
                required
                data-testid="login-password-input"
              />
            </div>
            {err && <p className="text-sm text-red-600" data-testid="login-error">{err}</p>}
            <Button
              type="submit"
              disabled={loading}
              className="w-full rounded-sm ep-amber hover:ep-amber"
              data-testid="login-submit-button"
            >
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </form>
        </Card>
        <p className="mt-10 text-xs text-slate-400">© {new Date().getFullYear()} Excellent Plastic LLC. All rights reserved.</p>
      </div>
      <div
        className="relative hidden md:block"
        style={{
          backgroundImage:
            'url("https://images.pexels.com/photos/221047/pexels-photo-221047.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940")',
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-[#0F2537]/80" />
        <div className="relative z-10 flex h-full flex-col justify-end p-16 text-white">
          <div className="max-w-md">
            <div className="text-xs uppercase tracking-[0.3em] text-white/70">Industrial • Reliable • Precise</div>
            <h3 className="font-heading mt-4 text-4xl font-bold leading-tight">
              Prepare quotes in minutes,<br/>not hours.
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-white/80">
              The fast, structured way to draft, track and deliver professional quotations to industrial clients across the GCC.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
